// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-row {
  border-bottom: var(--item-view-border);
  margin-bottom: 8px;
  padding: 10px 10px 20px;
}
.item-row .item-image {
  padding-right: 10px;
  opacity: 1;
  visibility: visible;
}
@media (max-width: 992px) {
  .item-row .item-image {
    width: 100px;
    height: 100px;
  }
}
@media (min-width: 991px) {
  .item-row {
    cursor: pointer;
    height: 100%;
    display: flex;
  }
}

@media (max-width: 992px) {
  .item-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
}
.item-text .item-name {
  font-family: var(--font-tusker);
  font-size: var(--item-view-title-font-size);
  line-height: var(--item-view-title-line-height);
  text-transform: uppercase;
  color: var(--ion-color-secondary);
  word-break: break-word;
}
.item-text .item-info {
  margin-top: 5px;
  margin-bottom: 12px;
  font-family: AppFont, sans-serif;
  color: #521340;
  font-size: 12px;
  line-height: 15px;
  word-break: break-word;
}
@media (min-width: 991px) {
  .item-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.item-text.vegan .item-name {
  color: #06331b;
}

.price {
  font-family: var(--font-tusker);
  font-size: 14px;
  line-height: 20px;
  color: var(--ion-color-secondary);
}
.price.vegan {
  color: #06331b;
}

.price-col {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  padding-bottom: 15px;
}
@media (max-width: 992px) {
  .price-col {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}
@media (min-width: 991px) {
  .price-col {
    padding: 0px 10px;
    align-items: flex-start;
  }
}
.price-col .action-icon {
  width: 28px;
  height: 28px;
  margin-top: 25px;
}
@media (min-width: 991px) {
  .price-col .action-icon {
    display: none;
  }
}

.img-block {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
}
@media (min-width: 991px) {
  .img-block {
    height: 120px;
    width: 100px;
  }
  .img-block ion-img {
    object-fit: contain;
    height: 100px;
  }
}
.img-block .item-image {
  position: relative;
}
.img-block .item-image.new-position {
  top: 16px;
}
@media (max-width: 992px) {
  .img-block .item-image.new-position {
    top: 31px;
  }
}
.img-block .add-article {
  display: none;
}
@media (min-width: 991px) {
  .img-block .add-article {
    display: block;
    position: absolute;
    top: 20%;
    right: 20%;
  }
}

.price-block {
  display: flex;
  align-items: center;
}
@media (max-width: 992px) {
  .price-block {
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
}
.price-block ion-img {
  margin-left: 10px;
}

.padding-left {
  padding-left: 10px;
}

.line {
  width: 0px;
  fill: transparent;
}
@media (max-width: 992px) {
  .line {
    width: 100%;
    fill: var(--ion-color-primary);
  }
}

@media (min-width: 991px) {
  .hide-big-screen {
    display: none !important;
  }
}

@media (max-width: 992px) {
  .hide-small-screen {
    display: none !important;
  }
}

.desktop-block-info {
  position: relative;
  height: 100%;
}
.desktop-block-info ion-icon {
  position: absolute;
  right: -10px;
  top: 10px;
  height: 60px;
  width: 2px;
}

.deposit_text {
  padding-top: 10px;
  font-size: 14px;
  font-family: Tusker, sans-serif;
  color: #878787;
}

.price_wrapper {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-end;
}

.relative-block {
  position: relative;
}
.relative-block .line-desktop {
  position: absolute;
  top: 0%;
  right: 0px;
  fill: var(--ion-color-primary);
  height: 90%;
  width: 3.5px;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: #9f9f9f;
  text-align: right;
  margin-top: 7px;
}
@media (max-width: 992px) {
  .measurment_text {
    text-align: left;
  }
}

.block_name_title {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.wrapper-article-info {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.wrapper-article-info .left {
  width: 65%;
  padding-right: 5px;
}
.wrapper-article-info .right {
  width: 35%;
}

.brand_image {
  height: 40px !important;
  width: 60px;
  object-fit: contain;
}
.brand_image.new-position {
  top: 22px;
}

.padding-top-item {
  margin-top: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-view/item-view.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,sCAAA;EACA,kBAAA;EACA,uBAAA;AADD;AAGC;EACC,mBAAA;EACA,UAAA;EACA,mBAAA;AADF;ACFE;EDAD;IAKE,YAAA;IACA,aAAA;EACD;AACF;ACdE;EDCF;IAgBE,eAAA;IACA,YAAA;IACA,aAAA;EACA;AACF;;ACfE;EDkBF;IAEE,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,uBAAA;EAAA;AACF;AACC;EACC,+BAAA;EACA,2CAAA;EACA,+CAAA;EACA,yBAAA;EACA,iCAAA;EACA,sBAAA;AACF;AAEC;EACC,eAAA;EACA,mBAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAAF;AC/CE;EDwBF;IA2BE,aAAA;IACA,sBAAA;IACA,8BAAA;EAAA;AACF;AAEE;EACC,cAAA;AAAH;;AAIA;EACC,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AADD;AAGC;EACC,cAAA;AADF;;AAIA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,oBAAA;AADD;ACrEE;EDiEF;IAOE,aAAA;IACA,uBAAA;IACA,sBAAA;EACA;AACF;AClFE;EDuEF;IAYE,iBAAA;IACA,uBAAA;EAGA;AACF;AADC;EACC,WAAA;EACA,YAAA;EAIA,gBAAA;AAAF;AC7FE;EDuFD;IAIE,aAAA;EAMD;AACF;;AAFA;EACC,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;AAKD;ACzGE;EDgGF;IAOE,aAAA;IACA,YAAA;EAMA;EALA;IACC,mBAAA;IACA,aAAA;EAOD;AACF;AAJC;EACC,kBAAA;AAMF;AAJE;EACC,SAAA;AAMH;ACnHE;ED4GA;IAGE,SAAA;EAQF;AACF;AALC;EACC,aAAA;AAOF;ACjIE;EDyHD;IAGE,cAAA;IACA,kBAAA;IACA,QAAA;IACA,UAAA;EASD;AACF;;AANA;EACC,aAAA;EACA,mBAAA;AASD;ACxIE;ED6HF;IAIE,sBAAA;IACA,uBAAA;IAEA,uBAAA;EAUA;AACF;AATC;EACC,iBAAA;AAWF;;AARA;EACC,kBAAA;AAWD;;AATA;EACC,UAAA;EACA,iBAAA;AAYD;AC3JE;ED6IF;IAIE,WAAA;IACA,8BAAA;EAcA;AACF;;ACvKE;ED2JF;IAEE,wBAAA;EAeA;AACF;;ACvKE;ED0JF;IAEE,wBAAA;EAgBA;AACF;;AAdA;EACC,kBAAA;EAQA,YAAA;AAUD;AAjBC;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AAmBF;;AAfA;EACC,iBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;AAkBD;;AAhBA;EACC,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,qBAAA;AAmBD;;AAjBA;EACC,kBAAA;AAoBD;AAnBC;EACC,kBAAA;EACA,OAAA;EACA,UAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;AAqBF;;AAlBA;EACC,gCAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAqBD;AC3NE;EDiMF;IAOE,gBAAA;EAuBA;AACF;;AArBA;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;AAwBD;;AAtBA;EACC,aAAA;EACA,8BAAA;EACA,WAAA;AAyBD;AAxBC;EACC,UAAA;EACA,kBAAA;AA0BF;AAxBC;EACC,UAAA;AA0BF;;AAvBA;EAKC,uBAAA;EACA,WAAA;EACA,mBAAA;AAsBD;AApBC;EACC,SAAA;AAsBF;;AAXA;EACC,gBAAA;AAcD","sourcesContent":["@import '../../../theme/mixins';\n\n.item-row {\n\tborder-bottom: var(--item-view-border);\n\tmargin-bottom: 8px;\n\tpadding: 10px 10px 20px;\n\n\t.item-image {\n\t\tpadding-right: 10px;\n\t\topacity: 1;\n\t\tvisibility: visible;\n\t\t@include mobile {\n\t\t\twidth: 100px;\n\t\t\theight: 100px;\n\t\t}\n\t}\n\n\t@include desktop {\n\t\tcursor: pointer;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\t// flex-direction: column;\n\t\t// flex-wrap: nowrap;\n\t}\n}\n.item-text {\n\t@include mobile {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tjustify-content: center;\n\t}\n\t.item-name {\n\t\tfont-family: var(--font-tusker);\n\t\tfont-size: var(--item-view-title-font-size);\n\t\tline-height: var(--item-view-title-line-height);\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-secondary);\n\t\tword-break: break-word;\n\t}\n\n\t.item-info {\n\t\tmargin-top: 5px;\n\t\tmargin-bottom: 12px;\n\t\tfont-family: AppFont, sans-serif;\n\t\tcolor: #521340;\n\t\tfont-size: 12px;\n\t\tline-height: 15px;\n\t\tword-break: break-word;\n\t}\n\n\t@include desktop {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t}\n\t&.vegan {\n\t\t.item-name {\n\t\t\tcolor: #06331b;\n\t\t}\n\t}\n}\n.price {\n\tfont-family: var(--font-tusker);\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: var(--ion-color-secondary);\n\n\t&.vegan {\n\t\tcolor: #06331b;\n\t}\n}\n.price-col {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tflex-direction: column;\n\tpadding-bottom: 15px;\n\t@include mobile {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tflex-direction: column;\n\t}\n\t@include desktop {\n\t\tpadding: 0px 10px;\n\t\talign-items: flex-start;\n\t}\n\n\t.action-icon {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t\tmargin-top: 25px;\n\t}\n}\n.img-block {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: center;\n\tposition: relative;\n\n\t@include desktop {\n\t\theight: 120px;\n\t\twidth: 100px;\n\t\tion-img {\n\t\t\tobject-fit: contain;\n\t\t\theight: 100px;\n\t\t}\n\t}\n\n\t.item-image {\n\t\tposition: relative;\n\n\t\t&.new-position {\n\t\t\ttop: 16px;\n\t\t\t@include mobile {\n\t\t\t\ttop: 31px;\n\t\t\t}\n\t\t}\n\t}\n\t.add-article {\n\t\tdisplay: none;\n\t\t@include desktop {\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 20%;\n\t\t\tright: 20%;\n\t\t}\n\t}\n}\n.price-block {\n\tdisplay: flex;\n\talign-items: center;\n\t@include mobile {\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\n\t\talign-items: flex-start;\n\t}\n\tion-img {\n\t\tmargin-left: 10px;\n\t}\n}\n.padding-left {\n\tpadding-left: 10px;\n}\n.line {\n\twidth: 0px;\n\tfill: transparent;\n\t@include mobile {\n\t\twidth: 100%;\n\t\tfill: var(--ion-color-primary);\n\t}\n}\n.hide-big-screen {\n\t@include desktop {\n\t\tdisplay: none !important;\n\t}\n}\n.hide-small-screen {\n\t@include mobile {\n\t\tdisplay: none !important;\n\t}\n}\n.desktop-block-info {\n\tposition: relative;\n\tion-icon {\n\t\tposition: absolute;\n\t\tright: -10px;\n\t\ttop: 10px;\n\t\theight: 60px;\n\t\twidth: 2px;\n\t}\n\theight: 100%;\n}\n.deposit_text {\n\tpadding-top: 10px;\n\tfont-size: 14px;\n\tfont-family: Tusker, sans-serif;\n\tcolor: #878787;\n}\n.price_wrapper {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n\talign-items: flex-end;\n}\n.relative-block {\n\tposition: relative;\n\t.line-desktop {\n\t\tposition: absolute;\n\t\ttop: 0%;\n\t\tright: 0px;\n\t\tfill: var(--ion-color-primary);\n\t\theight: 90%;\n\t\twidth: 3.5px;\n\t}\n}\n.measurment_text {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 10px;\n\tcolor: #9f9f9f;\n\ttext-align: right;\n\tmargin-top: 7px;\n\t@include mobile {\n\t\ttext-align: left;\n\t}\n}\n.block_name_title {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\talign-items: flex-start;\n}\n.wrapper-article-info {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\twidth: 100%;\n\t.left {\n\t\twidth: 65%;\n\t\tpadding-right: 5px;\n\t}\n\t.right {\n\t\twidth: 35%;\n\t}\n}\n.brand_image {\n\t// position: absolute;\n\t// top: -9px;\n\t// left: 50%;\n\t// transform: translateX(-50%);\n\theight:40px !important;\n\twidth: 60px;\n\tobject-fit: contain;\n\n\t&.new-position {\n\t\ttop: 22px;\n\t}\n\n\t// @include mobile {\n\t// \ttop: -10px;\n\n\t// \t&.new-position {\n\t// \t\ttop: 22px;\n\t// \t}\n\t// }\n}\n.padding-top-item {\n\tmargin-top: 15px;\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
